import { keyframesToDuration, mapRange } from '../../../utils/animationsUtils';
const name = 'Bounce';
const properties = {
    schema: {},
};
const keyframes_translateY = [
    { keyframe: 0, translateY: 0 },
    { keyframe: 8.8, translateY: -55 },
    { keyframe: 17.6, translateY: -87 },
    { keyframe: 26.5, translateY: -98 },
    { keyframe: 35.3, translateY: -87 },
    { keyframe: 44.1, translateY: -55 },
    { keyframe: 53.1, translateY: 0 },
    { keyframe: 66.2, translateY: -23 },
    { keyframe: 81, translateY: 0 },
    { keyframe: 86.8, translateY: -5 },
    { keyframe: 94.1, translateY: 0 },
    { keyframe: 97.1, translateY: -2 },
    { keyframe: 100, translateY: 0 },
];
const powerMap = {
    soft: { bounceFactor: 1 },
    medium: { bounceFactor: 2 },
    hard: { bounceFactor: 3 },
};
/**
 * Bounce animation object
 */
function animate(kit, elements, duration, delay, { power, intensity = 0.3, ...params } = {}) {
    const sequence = kit.sequence(params);
    const durations = keyframesToDuration(keyframes_translateY, duration);
    const responsiveBounceFactor = mapRange(0, 1, powerMap.soft.bounceFactor, powerMap.hard.bounceFactor, intensity);
    const bounceFactor = typeof power !== 'undefined'
        ? powerMap[power].bounceFactor
        : responsiveBounceFactor;
    keyframes_translateY.forEach(({ translateY }, index) => {
        sequence.add(kit.animate('BasePosition', elements, durations[index], 0, {
            to: { y: (translateY * bounceFactor) / 2 },
            ease: 'sineOut',
        }));
    });
    sequence.add(kit.animate('BaseNone', elements, delay, 0)); // add repeat delay
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=bounce.js.map